import React, { useContext } from "react";
import { AppContext } from "./../../contexts/AppContextProvider";
import { NavLink } from "react-router-dom";

const NavTenantsProjects = (props) => {
  const { dispatch } = useContext(AppContext);

  const switchTenant = (id, slug) => {
    localStorage.setItem("defaultTenantID", id);
    localStorage.setItem("defaultTenantSlug", slug);
    dispatch({
      type: "APP-SET-TENANT",
      tenantID: id,
      tenantSlug: slug,
    });
  };

  return props.tenants
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((tenant, key) => (
      <NavLink
        key={key}
        className={props.className}
        to={"/"}
        onClick={() => switchTenant(tenant.id, tenant.slug)}
      >
        {tenant.name}
      </NavLink>
    ));
};

export default NavTenantsProjects;
